import React, { useState } from "react";
import { Row, Col, DatePicker, Tag, Typography, message } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { patchAdmissionTherapySummaryApi } from "../../../../services/nutritionist.services";

const UpcomingReassessmentDate = ({
  date,
  admissionId,
  patientData,
  refreshPage,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    date
      ? dayjs(date)
      : patientData?.admission?.therapy_summary?.next_assessment_date
      ? dayjs(patientData?.admission?.therapy_summary?.next_assessment_date)
      : null
  );

  const daysLeft = selectedDate
    ? dayjs(selectedDate).startOf("day").diff(dayjs().startOf("day"), "day")
    : null;

  const handleDateChange = (dayjsDate) => {
    if (!dayjsDate) return;
    setSelectedDate(dayjsDate);

    patchAdmissionTherapySummaryApi({
      next_assessment_date: dayjsDate.format("YYYY-MM-DD"),
      admission: admissionId,
    })
      .then((res) => {
        message.success("Reassessment date updated successfully");
        refreshPage();
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "Failed to update date")
      );
  };

  return (
    <div className="ia-reassessment-date-bar">
      <Row align="middle" gutter={[12, 8]}>
        <Col xs={24} sm={24} md="auto">
          <Typography.Text strong>Upcoming Reassessment Date:</Typography.Text>
        </Col>
        <Col xs={24} sm={24} md="auto" className="ia-reassessment-date-picker-col">
          <DatePicker
            value={selectedDate}
            format="DD MMM YYYY"
            suffixIcon={<CalendarOutlined />}
            className="ia-reassessment-date-picker"
            onChange={handleDateChange}
            disabledDate={(current) =>
              current && current < dayjs().startOf("day")
            }
          />
        </Col>
        {daysLeft !== null && (
          <Col xs={24} sm={24} md="auto" className="ia-reassessment-due-col">
            <Typography.Text type="secondary" className="ia-reassessment-due-label">
              Due in
            </Typography.Text>
            <Tag
              className={`ia-reassessment-due-tag${
                daysLeft < 0 ? " ia-reassessment-due-tag--overdue" : ""
              }`}
            >
              {daysLeft < 0
                ? `Overdue by ${Math.abs(daysLeft)} Days`
                : `${daysLeft} Days`}
            </Tag>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default UpcomingReassessmentDate;
